"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("@amatiasq/util");
var util_2 = require("./util");
var Rectangle = /** @class */ (function () {
    function Rectangle() {
    }
    Rectangle.fromCenter = function (x, y, halfWidth, halfHeight) {
        var rect = new this();
        rect.x = x;
        rect.y = y;
        rect.halfWidth = halfWidth;
        rect.halfHeight = halfHeight;
        return rect;
    };
    Rectangle.fromXY = function (x, y, width, height) {
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        return this.fromCenter(x + halfWidth, y + halfHeight, halfWidth, halfHeight);
    };
    Rectangle.fromCoords = function (top, left, right, bottom) {
        return this.fromXY(left, top, right - left, bottom - top);
    };
    Rectangle.prototype.is = function (target) {
        return (this.x === target.x &&
            this.y === target.y &&
            this.width === target.width &&
            this.height === target.height);
    };
    Rectangle.prototype.containsPoint = function (target) {
        return util_2.containsPoint(this, target);
    };
    Rectangle.prototype.contains = function (target) {
        return util_2.contains(this, target);
    };
    Rectangle.prototype.collides = function (target) {
        return util_2.collides(this, target);
    };
    Rectangle.prototype.toString = function () {
        var _a = this, top = _a.top, left = _a.left, width = _a.width, height = _a.height;
        return "Rectangle(t:" + top + ",l:" + left + ",w:" + width + ",h:" + height + ")";
    };
    return Rectangle;
}());
exports.default = Rectangle;
Object.defineProperties(Rectangle.prototype, {
    x: util_1.accessor('_x', onHorizontalChange),
    y: util_1.accessor('_y', onVerticalChange),
    width: util_1.accessor('_width', onWidthChange),
    height: util_1.accessor('_height', onHeightChange),
    halfWidth: util_1.accessor('_halfWidth', onHalfWidthChange),
    halfHeight: util_1.accessor('_halfHeight', onHalfHeightChange),
    // When this properties are changed the position changes
    top: util_1.accessor('_top', onTopChange),
    left: util_1.accessor('_left', onLeftChange),
    right: util_1.accessor('_right', onRightChange),
    bottom: util_1.accessor('_bottom', onBottomChange),
});
function onHorizontalChange(rect) {
    rect._left = rect._x - rect._halfWidth;
    rect._right = rect._x + rect._halfWidth;
}
function onVerticalChange(rect) {
    rect._top = rect._y - rect._halfHeight;
    rect._bottom = rect._y + rect._halfHeight;
}
function onWidthChange(rect) {
    rect._halfWidth = rect._width / 2;
    onHorizontalChange(rect);
}
function onHeightChange(rect) {
    rect._halfHeight = rect._height / 2;
    onVerticalChange(rect);
}
function onHalfWidthChange(rect) {
    rect._width = rect._halfWidth * 2;
    onHorizontalChange(rect);
}
function onHalfHeightChange(rect) {
    rect._height = rect._halfHeight * 2;
    onVerticalChange(rect);
}
function onTopChange(rect, value, prev) {
    rect._y -= value - prev;
    onVerticalChange(rect);
}
function onLeftChange(rect, value, prev) {
    rect._x -= value - prev;
    onHorizontalChange(rect);
}
function onRightChange(rect, value, prev) {
    rect._x -= value - prev;
    onHorizontalChange(rect);
}
function onBottomChange(rect, value, prev) {
    rect._y -= value - prev;
    onVerticalChange(rect);
}
